import {combineReducers} from "redux";

import scenePlanetReducers from './scene-planet/reducers';
import clientRedditeducers from './client-reddit/reducers';

import App from './portfolio';

export const appReducers = {
    scenePlanet: combineReducers(scenePlanetReducers),
    clientReddit: combineReducers(clientRedditeducers),
    routes: () => ({portfolio: "", scenePlanet: "/scene-planet", clientReddit: "/client-reddit"})
};

export default App;


// WEBPACK FOOTER //
// ./src/apps/index.js